/* eslint-disable sort/imports */
import '@yandex-int/error-counter/dist/interfaceWithoutRum.js';
import '@yandex-int/error-counter/dist/implementation.js';
import '@yandex-int/error-counter/dist/sendWithoutRum.js';
import '@yandex-int/error-counter/dist/logError.js';

/* eslint-enable */

import { getAppVersion } from 'data-providers/versionAppProvider';

const ENVS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
};
const PROJECT = 'ecredit-v4-front';

class ErrorCounter {
  options;
  version;

  constructor(options = {}) {
    this.options = {
      ...options,
      debug: false,
      env: process.env.REACT_APP_MODE === 'development' ? ENVS.DEVELOPMENT : ENVS.PRODUCTION,
      project: PROJECT,
      resourceFails: false,
      uncaughtException: false,
    };
  }

  async send(params, error, settings) {
    if (!this.version) {
      const response = await getAppVersion();
      const { version } = response ?? {};

      this.version = version;
    }

    const version = this.version ?? '-1';

    if (window.Ya.Rum.getErrorSetting('project') !== PROJECT) {
      window.Ya.Rum.initErrors({ ...this.options, version });
    }

    window.Ya.Rum.logError(params, error, { ...settings, version });
  }
}

export const errorCounter = new ErrorCounter();
